var map = {
	"./blue.scss": [
		"a506",
		"chunk-76f0386f"
	],
	"./dark.scss": [
		"6e66",
		"chunk-74a82e1a"
	],
	"./light.scss": [
		"7f1c",
		"chunk-74b6aca8"
	],
	"./orange.scss": [
		"91e0",
		"chunk-74bb8106"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "d2a8";
module.exports = webpackAsyncContext;